import { useEffect } from "react";

function isTypingTarget(target) {
  if (!target) return false;
  if (target.isContentEditable) return true;
  const tag = (target.tagName || "").toLowerCase();
  return tag === "input" || tag === "textarea" || tag === "select";
}

// Lightweight global keyboard shortcut handler. Callers pass a map of
// combos -> handlers and an `enabled` flag.
export default function useKeyboardNav(bindings, { enabled = true } = {}) {
  useEffect(() => {
    if (!enabled) return undefined;

    const onKeyDown = (event) => {
      if (isTypingTarget(event.target) && !event.metaKey && !event.ctrlKey) return;

      const combo = [
        event.metaKey ? "meta" : null,
        event.ctrlKey ? "ctrl" : null,
        event.shiftKey ? "shift" : null,
        event.altKey ? "alt" : null,
        event.key?.toLowerCase(),
      ]
        .filter(Boolean)
        .join("+");

      const handler = bindings[combo] || bindings[event.key?.toLowerCase()];
      if (handler) {
        const handled = handler(event);
        if (handled !== false) {
          event.preventDefault();
          event.stopPropagation();
        }
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [bindings, enabled]);
}
